import React from 'react';
import { Image, Text } from '@goodfynd/ui';
import { Grid } from '@mui/material';

import strings from '../../../config/strings';

import { StyledContainer, StyledDescription, StyledItem } from './styles';

type BlockItem = {
  description: string;
  external?: boolean;
  image?: string;
  showTtitle?: boolean;
  title: string;
  url?: string;
};

const renderBlock = (item: BlockItem) => (
  <Grid item lg={4} xs={12}>
    {item.url ? (
      <StyledItem href={item.url}>{renderBlockContent(item)}</StyledItem>
    ) : (
      renderBlockContent(item)
    )}
  </Grid>
);

const renderBlockContent = (item: BlockItem) => (
  <>
    {!!item.image && <Image alt={item.title} height={65} src={item.image} />}

    <Text as="heading5">{item.title}</Text>
    <StyledDescription as="body2">{item.description}</StyledDescription>
  </>
);

export default function PanelValues() {
  return (
    <StyledContainer>
      <Text as="heading3" style={{ marginBottom: 32 }}>
        {strings.titles.ourValues}
      </Text>

      <Grid container spacing={4}>
        {renderBlock({
          title: 'Thoughtful Innovation',
          description: `We don't believe in innovation for innovation's sake. Rather we are obsessed with our customer and innovate to make their day-to-day responsibilities easier.`,
        })}

        {renderBlock({
          title: 'Simplicity',
          description: `We believe that simplicity is disruptive. It’s our duty to get to the core of complex problems, and to solve them with simple and effective solutions.`,
        })}

        {renderBlock({
          title: 'Transparency',
          description: `We never take for granted that using our technology is a choice! Therefore, transparency is at the heart of everything we do.`,
        })}
      </Grid>
    </StyledContainer>
  );
}
